// Controlador para Catálogo de Grupos de Empleados
// Siguiendo MODO1: cat_grupoempleado_controller
import axios from 'axios';
import { getApiUrl } from '@/config/api';
import authService from '@/shared/services/auth';

export default class CatGrupoEmpleadoService {
  constructor() {
    this.grupos = [];
    this.loading = false;
    this.error = null;
    this.selectedEmpresa = null;
  }

  async initialize() {
    await this.waitForEmpresa();
    await this.listar();
  }

  async waitForEmpresa() {
    let attempts = 0;
    const maxAttempts = 50;
    while (attempts < maxAttempts) {
      this.selectedEmpresa = authService.getSelectedEmpresa();
      if (this.selectedEmpresa && this.selectedEmpresa.EmpresaId) return;
      await new Promise(r => setTimeout(r, 100));
      attempts++;
    }
    this.error = 'No se pudo obtener la empresa seleccionada';
  }

  async listar() {
    this.loading = true;
    this.error = null;
    try {
      if (!this.selectedEmpresa || !this.selectedEmpresa.EmpresaId) {
        this.selectedEmpresa = authService.getSelectedEmpresa();
        if (!this.selectedEmpresa || !this.selectedEmpresa.EmpresaId) {
          this.loading = false;
          return { success: false, data: [], message: 'Debe elegir una empresa antes de poder continuar.' };
        }
      }

      const token = authService.getToken();
      if (!token) throw new Error('No hay token de autenticación');

      const response = await axios.post(getApiUrl('/api/GrupoEmpleado/listar'), {
        EmpresaId: this.selectedEmpresa.EmpresaId
      }, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      
      // Filtrar por empresa en el frontend como medida de seguridad adicional
      const allGrupos = response.data || [];
      this.grupos = allGrupos.filter(grupo => grupo.EmpresaId === this.selectedEmpresa.EmpresaId);
      this.loading = false;
      
      console.log('Grupos cargados:', this.grupos.length, 'de', allGrupos.length, 'total');
      console.log('Empresa del usuario:', this.selectedEmpresa.EmpresaId);
      this.loading = false;
      return { success: true, data: this.grupos };
    } catch (error) {
      this.error = error.message;
      this.grupos = [];
      this.loading = false;
      throw error;
    }
  }

  async guardar(grupo) {
    const token = authService.getToken();
    if (!token) throw new Error('No hay token de autenticación');
    grupo.EmpresaId = this.selectedEmpresa.EmpresaId;
    const response = await axios.post(getApiUrl('/api/GrupoEmpleado/guardar'), grupo, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    await this.listar();
    return { success: true, data: response.data, message: grupo.Clave ? 'Grupo actualizado' : 'Grupo creado' };
  }

  async borrar(grupo) {
    const token = authService.getToken();
    if (!token) throw new Error('No hay token de autenticación');
    const response = await axios.post(getApiUrl('/api/GrupoEmpleado/borrar'), grupo, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    await this.listar();
    return { success: true, data: response.data, message: 'Grupo eliminado' };
  }

  async lectura(clave) {
    const token = authService.getToken();
    if (!token) throw new Error('No hay token de autenticación');
    const response = await axios.post(getApiUrl('/api/GrupoEmpleado/lectura'), {
      Clave: clave,
      EmpresaId: this.selectedEmpresa.EmpresaId
    }, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return { success: true, data: response.data };
  }

  async recargar() { await this.listar(); }

  async downloadBulk() {
    // TODO: Implementar endpoint de descarga en el backend
    throw new Error('Funcionalidad de descarga no implementada en el backend');
  }
}


